import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/base/SectionHeading";
import { usePageMeta } from "@/hooks/usePageMeta";

const stats = [
  { value: "4", label: "内容板块", icon: "ri-layout-grid-line" },
  { value: "19+", label: "精选作品", icon: "ri-movie-2-line" },
  { value: "6", label: "主题专题", icon: "ri-bookmark-3-line" },
  { value: "每日", label: "资讯更新", icon: "ri-flashlight-line" },
];

const contacts = [
  { icon: "ri-mail-line", label: "商务合作", value: "hello@bangbangtv.demo", href: "mailto:hello@bangbangtv.demo" },
  { icon: "ri-customer-service-2-line", label: "内容建议", value: "content@bangbangtv.demo", href: "mailto:content@bangbangtv.demo" },
  { icon: "ri-wechat-line", label: "微信公众号", value: "棒棒TV影视", href: "#" },
  { icon: "ri-weibo-line", label: "官方微博", value: "@棒棒TV", href: "#" },
];

const guides = [
  { icon: "ri-compass-3-line", title: "按分类浏览", desc: "通过顶部导航进入电影、电视剧、综艺或纪录片频道，并按类型、地区、年份和评分筛选。" },
  { icon: "ri-search-line", title: "搜索影视内容", desc: "在搜索页输入作品名称、类型或演员，即可快速匹配感兴趣的影视作品。" },
  { icon: "ri-bookmark-3-line", title: "收藏想看内容", desc: "在详情页点击收藏按钮，作品会保存在你的浏览器本地，方便随时回看。" },
  { icon: "ri-folder-open-line", title: "浏览专题合集", desc: "在专题页按主题查看成组推荐，从年度大片到治愈综艺，一次看个够。" },
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 棒棒TV影视资讯平台介绍",
    description:
      "了解棒棒TV的定位与品牌故事：一个专注影视剧资讯与精选推荐的内容平台，涵盖电影、电视剧、综艺与纪录片。",
    keywords: "关于棒棒TV,棒棒TV介绍,影视资讯平台,品牌故事,影视推荐网站",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <section className="bg-primary-950 px-4 py-14 md:px-8 md:py-20">
          <div className="mx-auto max-w-[1180px]">
            <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-4xl">
              用更懂观众的方式，做影视资讯
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
              棒棒TV 是一个专注影视剧资讯与精选推荐的综合内容平台。我们相信，在内容爆炸的时代，最重要的不是"看得更多"，而是"看得更好"。因此我们坚持用清晰的分类、真诚的推荐与用心的专题，帮观众把时间花在真正值得的作品上。
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
              {stats.map((item) => (
                <div key={item.label} className="rounded-lg bg-primary-900 px-4 py-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-accent-500">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <p className="mt-3 font-heading text-2xl font-black text-background-50">
                    {item.value}
                  </p>
                  <p className="mt-1 text-xs text-background-400">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="mx-auto max-w-[1180px] px-4 py-10 md:px-8 md:py-14">
          <section>
            <SectionHeading title="品牌故事" icon="ri-quill-pen-line" />
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
              <div className="space-y-4 text-sm leading-7 text-foreground-700">
                <p>
                  棒棒TV 起源于一群影视爱好者的一个小愿望：如果有一个地方，既能第一时间看到最新影视资讯，又能被真诚地推荐真正好看的电影和剧集，那该多好。
                </p>
                <p>
                  于是我们搭建了这个平台。它不追求海量堆砌，而是把每一部作品都认真看过、想过，再决定是否推荐。我们用专题把作品重新串联，用分类让浏览更高效，用评分与热度呈现大众的真实选择。
                </p>
                <p>
                  未来，棒棒TV 会持续丰富内容与栏目，也欢迎每一位观众提出建议。我们的目标很简单——成为你打开就会想看点什么的地方。
                </p>
              </div>
              <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-6">
                <h3 className="flex items-center gap-2 text-base font-bold text-secondary-900">
                  <i className="ri-focus-3-line"></i>
                  我们的定位
                </h3>
                <ul className="mt-4 space-y-3 text-sm text-foreground-700">
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                    影视剧资讯与精选推荐平台
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                    覆盖电影、电视剧、综艺、纪录片
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                    以分类、专题与推荐提升浏览效率
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                    面向所有热爱影视的普通观众
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-12">
            <SectionHeading title="联系我们" icon="ri-customer-service-2-line" />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {contacts.map((contact) => (
                <a
                  key={contact.label}
                  href={contact.href}
                  className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                    <i className={`${contact.icon} text-xl`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-xs text-foreground-500">{contact.label}</span>
                    <span className="block truncate text-sm font-semibold text-foreground-900">
                      {contact.value}
                    </span>
                  </span>
                </a>
              ))}
            </div>
          </section>

          <section className="mt-12">
            <SectionHeading title="使用说明" icon="ri-guide-line" />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {guides.map((guide) => (
                <div
                  key={guide.title}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                    <i className={`${guide.icon} text-xl`}></i>
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-foreground-900">{guide.title}</span>
                    <span className="mt-1 block text-xs leading-relaxed text-foreground-600">
                      {guide.desc}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-12 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-copyright-line text-primary-600"></i>
              版权与免责声明
            </h2>
            <div className="mt-4 space-y-3 text-xs leading-relaxed text-foreground-600">
              <p>
                本站展示的影视作品名称、剧情、导演与演员等信息均为虚构演示内容，仅用于网站功能与界面展示，与任何真实作品或个人无关。
              </p>
              <p>
                棒棒TV 不提供任何影视播放、下载或付费服务，站内所有内容均为资讯介绍与推荐信息。
              </p>
              <p>
                © 2025 棒棒TV 保留本站设计、结构与原创文字内容的相关权利。如需转载或合作，欢迎通过上方联系方式与我们取得联系。
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}